// src/app/interceptors/auth.interceptor.ts
import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs';
import {
  createForbiddenRoute,
  createLoginRoute,
} from './constants/route_generation';
import { Auth } from './services/auth';

export const unauthorizedInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
) => {
  const router = inject(Router);
  const authService = inject(Auth);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        authService.logout();
        router.navigateByUrl(createLoginRoute());
      }
      if (error.status === 403) {
        router.navigateByUrl(createForbiddenRoute());
      }
      throw error;
    })
  );
};
